import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminManualReferralsApi } from '../services/adminManualReferralsApi';
import type {
  CreateManualReferralPayload,
  ManualReferralResponse,
} from '../types/manual-referral.type';

export const useCreateManualReferral = () => {
  const queryClient = useQueryClient();

  return useMutation<ManualReferralResponse, Error, CreateManualReferralPayload>({
    mutationFn: (payload) => adminManualReferralsApi.createManualReferral(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['analytics'] });
    },
  });
};
